import { ElementOf, tuple } from '../common/props';
export type AlignmentType = ElementOf<typeof Alignment>;
const Alignment = tuple('left', 'center', 'right');
